import * as Yup from 'yup';

export function userInfoSchema(enableDailyQueueAssignedLocations: boolean) {
  return Yup.object().shape({
    firstName: Yup.string().required('First Name is Required'),
    lastName: Yup.string().required('Last Name is Required'),
    email: Yup.string().required('Email is Required').email(),
    mobilePhoneNumber: Yup.string()
      .test('valid-phone-number', '*Incorrect formatting', (phoneNumber) =>
        phoneNumber ? /^[0-9]{10}$/.test(phoneNumber) : true
      )
      .test(
        'start-with-zero',
        'Phone number can not begin with 0',
        (phoneNumber) => !(phoneNumber && phoneNumber[0] === '0')
      ),
    role: Yup.string().required('Role is Required').nullable(),
    jobTitle: Yup.string().when('role', (role) => {
      return role === 'onsite_staff' ? Yup.string().required('Job Title is Required') : Yup.string().nullable();
    }),
    defaultAccountLocation: Yup.object().when('role', (role) => {
      return role === 'onsite_staff' && !enableDailyQueueAssignedLocations
        ? Yup.object().required('Location is Required').nullable()
        : Yup.object().nullable();
    }),
    accountLocations: Yup.object().when('role', (role) => {
      return role === 'onsite_staff' && enableDailyQueueAssignedLocations
        ? Yup.array()
            .required('At least one location is required')
            .min(1, 'At least one location is required')
            .nullable()
        : Yup.array().nullable();
    }),
  });
}
